import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import amplitude from 'amplitude-js';
import smartlookClient from 'smartlook-client';
import { logoutUser } from '../actions/api';
import * as types from '../constants/ActionTypes';
import withGTag from '../components/withGTag';
import { GOOGLE_ANALYTICS_ID, IS_APP_CODEAC } from '../constants/env';
import Layout from '../containers/Layout';
import Icon from '../components/Icon';
class LogoutPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            redirect: null,
        };
    }
    componentDidMount() {
        let redirect = true;
        if (localStorage.getItem('customVcs')) {
            redirect = localStorage.getItem('customVcs');
            localStorage.removeItem('customVcs');
        }
        this.props.dispatch(logoutUser()).then(() => {
            const eventName = 'logout';
            amplitude.getInstance().logEvent(eventName);
            amplitude.getInstance().setUserId(null);
            amplitude.getInstance().regenerateDeviceId();
            smartlookClient.track(eventName, {});
            smartlookClient.anonymize();
            localStorage.removeItem('token');
            sessionStorage.removeItem('noTrack');
            this.props.gtag('config', GOOGLE_ANALYTICS_ID, { user_id: null }); // eslint-disable-line camelcase
            this.props.dispatch({ type: types.LOGOUT_USER });
            this.setState({ redirect: redirect });
        });
    }
    render() {
        const { 
        // user,
        match, t, } = this.props;
        if (this.state.redirect) {
            return _jsx(Redirect, { to: `/login` + (this.state.redirect !== true ? '/' + this.state.redirect : ''), push: true });
        }
        return (_jsx(Layout, { loginRequired: true, match: match, children: _jsxs("div", { className: IS_APP_CODEAC ? 'loading-container' : 'text-center', children: [_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "3x", className: "repositories__spinner" }), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] }) }));
    }
}
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default withGTag(connect(void 0, mapDispatchToProps)(withTranslation()(LogoutPage)));
